module.exports = __webpack_public_path__ + "media/simulation.ceaae8e4.webm";